export enum MenuType {
  DisplayMenu = 'DISPLAY_MENU',
  MarketingMenu = 'MARKETING_MENU',
  PrintMenu = 'PRINT_MENU',
  PrintCardMenu = 'PRINT_CARD_MENU',
  WebMenu = 'WEB_MENU',
  WebSpotlightMenu = 'WEB_SPOTLIGHT_MENU'
}
